import "./App.css";
import Card from "./components/Card";
import { Box } from "@chakra-ui/react";

function App() {
  return (
    <Box as="main">
      <Card />
    </Box>
  );
}

export default App;
